import React from "react";
import {useTranslation} from "react-i18next";
import {Stack} from "@mui/material";

const SimpleSpinner = (): any => {
    const {t} = useTranslation()

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{
                p: 3
            }}
        >
            <span>{t("common.loading")}</span>
            <div className="loader"></div>
        </Stack>
    );
}

export default SimpleSpinner;